import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import arabicTranslate from './locales/ar.json';
import englishTranslate from './locales/en.json';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['localStorage', 'htmlTag', 'navigator', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
    resources: {
      en: {
        translation: englishTranslate,
      },
      ar: {
        translation: arabicTranslate,
      },
    },
    fallbackLng: 'ar',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
